import React from 'react';

import { SimpleImage } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ColumnTextCardBlock}
 */

const ColumnTextCard = ({
    title,
    richText,
    backgroundColor,
    cardItems
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} col-padding pt-24 pb-16 grid gap-y-24 sm:gap-y-0 sm:grid-cols-2 gap-x-8 md:gap-x-16 rounded-lg`}>
            <div className='w-full'>
                <h2 className='type-style-sans-h1'>
                    {title}
                </h2>
                {richText && (
                    <div
                        className='rich-text type-style-sans-h3 mt-8 w-full md:w-5/6'
                        dangerouslySetInnerHTML={{__html: richText }}/>
                )}
            </div>

            <div className='bg-surface-raised rounded-lg py-10 md:py-12 px-16 md:px-24'>
                {cardItems.map((item, idx) => {
                    return (
                        <div
                            className={`${idx ? 'border-t border-border-default' : ''} flex flex-row py-16 md:py-24 items-center gap-x-32`}
                            key={item.id}>
                            <figure className='h-48 w-48 flex flex-shrink-0'>
                                <SimpleImage {...item.icon}/>
                            </figure>
                            <div className='flex flex-col'>
                                <p className='type-style-sans-h3-med'>
                                    {item.title}
                                </p>
                                {item.text && (
                                    <p className='type-style-sans-body mt-4'>
                                        {item.text}
                                    </p>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ColumnTextCard;
